export default "assets/images/4-stars-f0340b3a.svg";